import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LovDataService {

  private _lovDataApi = `${environment.common}`;
  private _countriesApi = `${environment.integration}`;

  constructor(
    private _http: HttpClient,
    private _router: Router
  ) { }

  getAuditData(entityId: any, entityType: any): Observable<any> {
    const paginationSettings = {
      pageNumber: -1,
      pageSize: -1
    }
    return this._http.post<any>(`${environment.common}/audits/${entityType}/${entityId}`, paginationSettings);
  }


  getLovData(type: any): Observable<any> {
    return this._http.get<any>(`${this._lovDataApi}/GetLovData/${type}`);
  }

  addLovData(type: any, formData: any): Observable<any> {
    return this._http.post<any>(`${this._lovDataApi}/AddLovData/${type}`, formData);
  }

  getLovItineraryData(type: any): Observable<any> {
    return this._http.get<any>(`${this._lovDataApi}/GetLovItineraryData/${type}`);
  }

  addLovItineraryData(type: any, formData: any): Observable<any> {
    return this._http.post<any>(`${this._lovDataApi}/AddLovItineraryData/${type}`, formData);
  }

  // Get all users data
  GetAllUsersData(): Observable<any> {
    return this._http.get<any>(`${this._lovDataApi}/GetUsers`);
  }

  // Get single user
  getUser(userId: any): Observable<any> {
    return this._http.get<any>(`${this._lovDataApi}/users/user/${userId}`)
  }

  // Get list of countires
  GetCountries(): Observable<any> {
    return this._http.get<any>(`${this._countriesApi}/GetCountriesData`);
  }

  uploadImage(formData: any, type: string): Observable<any> {
    return this._http.post<any>(`${environment.common}/upload/${type}`, formData);
  }

  addDefaultLovData(type: any, formData: any): Observable<any> {
    return this._http.post<any>(`${this._lovDataApi}/AddLovData/${type}`, formData);
  }

  removeDefaultLovData(type: any, id: any): Observable<any> {
    return this._http.delete<any>(`${this._lovDataApi}/lovdata/${type}/${id}`);
  }
}
